/**
 * ReportingNowBadge — small circular "R" shown in the narrow live-report-status
 * column when a study is currently open in the report editor by some user
 * (order_workflow.ow_reporting_status === 'R'). The study is locked while this
 * is set, so it doubles as an "in use" indicator.
 *
 * Replaces the bare "R" text with a styled, tooltip-backed badge. Renders
 * nothing when no one has the study open, keeping the column empty as before.
 */
import React from 'react';
import { Tooltip } from 'antd';

export const ReportingNowBadge: React.FC<{ status?: string | null }> = ({ status }) => {
  if (status !== 'R') return null;

  return (
    <Tooltip title="Currently being reported">
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          background: '#4263EB',
          color: '#fff',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 700,
          fontSize: '11px',
          lineHeight: '20px',
          letterSpacing: 0,
        }}
      >
        R
      </span>
    </Tooltip>
  );
};

export default ReportingNowBadge;
